import { session } from 'wix-storage';

export function setRefreshCartFlag(value) {
    session.setItem("refreshCartFromLightbox", value ? "true" : "false")
}

export function getRefreshCartFlag() {
    return session.getItem("refreshCartFromLightbox") === "true";
}
